import { Pagination, Sorting } from './types'

export const defaultPagination: Pagination = {
  page: 1,
  perPage: 25,
  total: 0,
}

export const defaultSorting: Sorting = {
  sortBy: 'name',
  sortingOrder: 'desc',
}
